export type RepoRole = 'site' | 'api' | 'agent-api' | 'infra' | 'unknown';

export function normalizeRepoRole(raw: unknown): RepoRole | undefined {
  const value = String(raw ?? '').trim().toLowerCase();
  if (value === 'site' || value === 'api' || value === 'agent-api' || value === 'infra' || value === 'unknown') {
    return value;
  }
  return undefined;
}

export function inferRepoRoleFromRepoRef(
  repo: { owner?: string; repo?: string; name?: string; role?: unknown } | null | undefined
): RepoRole {
  const explicit = normalizeRepoRole(repo?.role);
  if (explicit) return explicit;
  const text = `${String(repo?.owner ?? '')} ${String(repo?.repo ?? repo?.name ?? '')}`.toLowerCase();
  if (/(frontend|site|web|ui|client)/.test(text)) return 'site';
  if (/(agent-api|machine-agent-api|orchestrator|agent)/.test(text)) return 'agent-api';
  if (/(infra|ops|terraform|k8s|deploy)/.test(text)) return 'infra';
  if (/(api|backend|server|service)/.test(text)) return 'api';
  return 'unknown';
}

export function inferRepoRoleFromTicket(ticket: { title?: string; description?: string } | null | undefined): RepoRole {
  const text = `${String(ticket?.title ?? '')} ${String(ticket?.description ?? '')}`.toLowerCase();
  if (/(button|ui|screen|component|css|style|layout|page|frontend|angular)/.test(text)) return 'site';
  if (/(endpoint|controller|service|api|route|http|auth|database|migration|schema)/.test(text)) return 'api';
  if (/(agent|orchestrator|prompt|tool|langchain|machine-agent-api)/.test(text)) return 'agent-api';
  if (/(docker|k8s|infra|terraform|deployment|pipeline|ci\/cd)/.test(text)) return 'infra';
  return 'unknown';
}
